import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-cr",
  "use": "icon-icon-cr-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-cr\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#0000b4\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#fff\" d=\"M0 80.5h512v343.7H0z\" />\n    <path fill=\"#d90000\" d=\"M0 168.2h512v168.2H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol